import { ActionType, getType } from "typesafe-actions";
import * as teaserActions from "./teaser-actions";
import update from "immutability-helper";
import { ITeaserTile } from "~/components/teaser-grid/teaser-tile/teaser-tile";
export type TeaserAction = ActionType<typeof teaserActions>;

export interface TeaserParams {
    page?: number;
    loadMorePageSize?: number;
    filterTags?: string[];
}

export interface TeaserState {
    readonly isLoadMorePending: boolean;
    readonly teaserParams: TeaserParams;
    readonly teaserList?: ITeaserTile[];
    readonly displayedTeasersOutOfTotalLabel?: string;
    readonly teasersTotalCount?: number;
}

export const initialState: TeaserState = {
    isLoadMorePending: false,
    teaserParams: {}
};

const teaserReducer = (state: TeaserState = initialState, action: TeaserAction) => {
    switch (action.type) {
        case getType(teaserActions.teaserRequest):
            return update(state, {
                isLoadMorePending: { $set: true }
            });
        case getType(teaserActions.teaserSuccess):
            return update(state, {
                isLoadMorePending: { $set: false },
                teaserList:
                    action.payload.page !== 0
                        ? { $push: action.payload.teaserList }
                        : { $set: action.payload.teaserList },
                displayedTeasersOutOfTotalLabel: { $set: action.payload.displayedTeasersOutOfTotalLabel },
                teasersTotalCount: { $set: action.payload.teasersTotalCount }
            });
        case getType(teaserActions.teaserError):
            return update(state, { isLoadMorePending: { $set: false } });
        case getType(teaserActions.populateTeasers):
            return update(state, { teaserList: { $set: action.payload.teaserList } });
        case getType(teaserActions.updateTeaserParams):
            return update(state, {
                teaserParams: { $merge: action.payload }
            });
        default:
            return state;
    }
};

export default teaserReducer;
